module.exports = __webpack_public_path__ + "static/img/h33.a6d79d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h33.jpg
// module id = 5vmc
// module chunks = 0